import Vue from 'vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'


Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.component(XHeader.name, XHeader)



// WEBPACK FOOTER //
// ./src/plugins/vux.js